import React, { Fragment, useState, useEffect } from "react";
import { Loader } from "./Loader";
import { Header } from "./Header";
import { Footer } from "./Footer";
export function Work() {

   const [data2, enterData2] = useState(true);

   useEffect(() => {
     setTimeout(() => {
       enterData2(false);
     }, 2500);
   }, []);


  return (
    <Fragment>
       <div className="inner" style={{marginBottom: 100}}>
      <Header/>
      {data2 && <Loader />}
      <h1 style={{ textAlign: "center" }}>My Works</h1>
      <p style={{ textAlign: "center" }}>Click to view each projects.</p>
      <section className="tiles">
        
        <article className="style7">
          <span className="image">
            <img
              src="/images/works/ecard.jpeg"
              alt="promise shedrach - my services"
            />
          </span>
          <a href="https://e-cardmarket.com.ng/" target="__blank">
            <div className="content">
              <p style={{ backgroundColor: "black", padding: 50 }}>
                Built with Laravel and Livewire <br />
                <button className="button primary">VIEW</button>
              </p>
            </div>
          </a>
        </article>

        <article className="style7">
          <span className="image">
            <img
              src="/images/works/p.jpeg"
              alt="promise shedrach - my services"
            />
          </span>
          <a href="https://promiseshedrach.netlify.app/" target="__blank">
            <div className="content">
              <p style={{ backgroundColor: "black", padding: 50 }}>
                Built with React Js
                <br />      
                <button className="button primary">VIEW</button>
              </p>
            </div>
          </a>
        </article>

        <article className="style7">
          <span className="image">
            <img
              src="/images/works/intech.jpg"
              alt="promise shedrach - my services"
            />
          </span>
          <a href="https://intech.org.ng" target="__blank">
            <div className="content">
              <p style={{ backgroundColor: "black", padding: 50 }}>
              Built with Laravel and JQuery  <br />
                <button className="button primary">VIEW</button>
              </p>
            </div>
          </a>
        </article>

        <article className="style7">
          <span className="image">
            <img src="/images/works/vg.jpeg" alt="promise shedrach - my works" />
          </span>
          <a href="https://virgobeautyonline.com/" target="__blank">
            <div className="content">
              <p style={{ backgroundColor: "black", padding: 50 }}>
              Built with Laravel and Livewire <br />
                <button className="button primary">VIEW</button>
              </p>
            </div>
          </a>
        </article>

        <article className="style7">
          <span className="image">
            <img
              src="/images/works/du.jpeg"
              alt="promise shedrach about me"
            />
          </span>
          <a href="https://de-ugwums.realestateconsultants.com.ng/" target="__blank" >
            <div className="content">
              <p style={{ backgroundColor: "black", padding: 50 }}>
                Built with Laravel and Livewire <br />
                <button className="button primary">VIEW</button>
              </p>
            </div>
          </a>
        </article>
      </section>
      </div>
      <Footer/>
    </Fragment>
  );
}
